// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function BooksBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29.446 24.216 25.297 4.491a2.5 2.5 0 0 0-2.97-1.935l-5.85 1.258a2.478 2.478 0 0 0-1.376.831A2.5 2.5 0 0 0 13 3.5H7A2.5 2.5 0 0 0 4.5 6v20A2.5 2.5 0 0 0 7 28.5h6a2.5 2.5 0 0 0 2.5-2.5V11.281l3.203 15.228a2.5 2.5 0 0 0 2.97 1.935l5.85-1.258a2.513 2.513 0 0 0 1.923-2.97ZM18.524 11.081l4.875-1.047.316 1.5-4.875 1.047-.316-1.5Zm.932 4.438 4.875-1.048 1.145 5.448-4.875 1.047-1.145-5.447Zm3.008-9.924.316 1.5-4.875 1.048-.316-1.5 4.875-1.048ZM7.5 11h5v10h-5V11Zm5-4.5V8h-5V6.5h5Zm-5 19V24h5v1.5h-5Zm14.036-.095-.316-1.5 4.875-1.047.316 1.5-4.875 1.047Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
